import * as React from "react";
const SvgIcon61 = props => <svg xmlns="http://www.w3.org/2000/svg" fill="none" width="1em" height="1em" viewBox="0 0 19 19" {...props}><defs><style>{".icon_61_svg__cls-2{fill:currentColor}"}</style></defs><circle cx={9.5} cy={9.5} style={{
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.67,
    strokeLinecap: "ROUND"
  }} r={8.67} /><g transform="rotate(-45 4.935 9.27)"><rect x={4.96} y={9.3} width={1.78} height={5} rx={0.89} className="icon_61_svg__cls-2" /><rect x={5.46} y={9.8} width={0.78} height={4} rx={0.39} style={{
      fillOpacity: 0,
      strokeOpacity: 1,
      strokeWidth: 1
    }} /></g><g transform="rotate(45 12.727 6.108)"><rect x={12.78} y={6.13} width={1.78} height={7.75} rx={0.89} className="icon_61_svg__cls-2" /><rect x={13.28} y={6.63} width={0.78} height={6.75} rx={0.39} style={{
      fillOpacity: 0,
      strokeOpacity: 1,
      strokeWidth: 1
    }} /></g></svg>;
export default SvgIcon61;